import { render, staticRenderFns } from "./RButton.vue?vue&type=template&id=52e1eb3e"
import script from "./RButton.vue?vue&type=script&lang=js"
export * from "./RButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports